import { DSButton, Translate } from '@deltasierra/components';
import * as React from 'react';
import { withAngularIntegration } from '../../../common/componentUtils/reactComponentRegistration';

export function PlannerOverviewLinkButton(): JSX.Element {
    return (
        <a href="/overview" style={{ marginLeft: '8px' }}>
            <DSButton color="primary">
                <Translate keyId="PLAN.CAMPAIGNS.OVERVIEW" />
            </DSButton>
        </a>
    );
}
PlannerOverviewLinkButton.displayName = 'PlannerOverviewLinkButton';

export const angularPlannerOverviewLinkButton = withAngularIntegration(
    PlannerOverviewLinkButton,
    'plannerOverviewLinkButton',
    {},
);
